import { render, staticRenderFns } from "./employer-budgets.vue?vue&type=template&id=affda666"
import script from "./employer-budgets.vue?vue&type=script&lang=js"
export * from "./employer-budgets.vue?vue&type=script&lang=js"
import style0 from "./employer-budgets.vue?vue&type=style&index=0&id=affda666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports